<i18n lang="yaml">
en:
  course_base_price: Course fee
  course_price_with_commitment: "{price} × {months} months"
  coupon_discount: Coupon {coupon}
  month: month
  schedule: Schedule
  start_date: Start date
  instructors: Instructors
  months_discount: months discount
  total_to_pay: Total to pay
  payable_now: Payable now
  next_payment_on: "Next payment on {date}"
  total_counted: "{base_price} × {duration} month | {base_price} × {duration} months"
  subscription_with_commitment_title: Monthly payment with commitment period
  subscription_with_commitment_description: "This is a subscription with a minimum commitment period of {months} months, until {date}. The subscription will continue automatically after that date until you cancel it. You cannot cancel the subscription before the commitment period ends."
  subscription_flexible_title: Monthly payment
  subscription_flexible_description: "This is a flexible subscription that continues automatically each month until you cancel it. You can cancel at any time, and the cancellation will take effect at the next renewal date."
  products: Addons
  products_one_time: "(one-time)"
nb:
  course_base_price: Kursavgift
  course_price_with_commitment: "{price} × {months} måneder"
  coupon_discount: Rabattkode {coupon}
  month: måned
  schedule: Timeplan
  start_date: Startdato
  instructors: Kursholdere
  months_discount: måneders rabatt
  total_to_pay: Totalt å betale
  payable_now: Å betale nå
  next_payment_on: "Neste betaling den {date}"
  total_counted: "{base_price} × {duration} måned | {base_price} × {duration} måneder"
  subscription_with_commitment_title: Månedlig betaling med bindingstid
  subscription_with_commitment_description: "Dette er et abonnement med bindingstid på {months} måneder, til {date}. Abonnementet fortsetter automatisk etter denne datoen inntil du kansellerer det. Du kan ikke avslutte abonnementet før bindingstiden utløper."
  subscription_flexible_title: Månedlig betaling
  subscription_flexible_description: "Dette er et fleksibelt abonnement som fornyes automatisk hver måned inntil du kansellerer det. Du kan kansellere når som helst, og kanselleringen trer i kraft fra neste fornyelsesdato."
  products: Tillegg
  products_one_time: "(engangsbeløp)"
es:
  course_base_price: Cuota del curso
  course_price_with_commitment: "{price} × {months} meses"
  coupon_discount: Cupón {coupon}
  month: mes
  schedule: Horario
  start_date: Fecha de inicio
  instructors: Instructores
  months_discount: descuento de meses
  total_to_pay: Total a pagar
  payable_now: A pagar ahora
  next_payment_on: "Próximo pago el {date}"
  total_counted: "{base_price} × {duration} mes | {base_price} × {duration} meses"
  subscription_with_commitment_title: Pago mensual con período de compromiso
  subscription_with_commitment_description: "Esta es una suscripción con un período mínimo de compromiso de {months} meses, hasta el {date}. La suscripción continuará automáticamente después de esa fecha hasta que la cancele. No puede cancelar la suscripción antes de que finalice el período de compromiso."
  subscription_flexible_title: Pago mensual
  subscription_flexible_description: "Esta es una suscripción flexible que continúa automáticamente cada mes hasta que la cancele. Puede cancelar en cualquier momento y la cancelación tendrá efecto en la próxima fecha de renovación."
  products: Materiales
  products_one_time: "(único)"
uk:
  course_base_price: Плата за курс
  course_price_with_commitment: "{price} × {months} місяців"
  coupon_discount: Купон {coupon}
  month: місяць
  schedule: Розклад
  start_date: Дата початку
  instructors: Викладачі
  months_discount: знижка на місяці
  total_to_pay: Всього до оплати
  payable_now: До сплати зараз
  next_payment_on: "Наступний платіж {date}"
  total_counted: "{base_price} × {duration} місяць | {base_price} × {duration} місяці | {base_price} × {duration} місяців"
  subscription_with_commitment_title: Щомісячний платіж з періодом зобов'язання
  subscription_with_commitment_description: "Це підписка з мінімальним періодом зобов'язання {months} місяців, до {date}. Підписка продовжуватиметься автоматично після цієї дати, поки ви її не скасуєте. Ви не можете скасувати підписку до закінчення періоду зобов'язання."
  subscription_flexible_title: Щомісячний платіж
  subscription_flexible_description: "Це гнучка підписка, яка автоматично продовжується щомісяця, поки ви її не скасуєте. Ви можете скасувати в будь-який час, і скасування набуде чинності на наступну дату поновлення."
  products: Матеріали
  products_one_time: "(одноразово)"
pl:
  course_base_price: Opłata za kurs
  course_price_with_commitment: "{price} × {months} miesięcy"
  coupon_discount: Kupon {coupon}
  month: miesiąc
  schedule: Harmonogram
  start_date: Data rozpoczęcia
  instructors: Instruktorzy
  months_discount: rabat na miesiące
  total_to_pay: Całkowita kwota do zapłaty
  payable_now: Do zapłaty teraz
  next_payment_on: "Następna płatność {date}"
  total_counted: "{base_price} × {duration} miesiąc | {base_price} × {duration} miesiące | {base_price} × {duration} miesięcy"
  subscription_with_commitment_title: Płatność miesięczna z okresem zobowiązania
  subscription_with_commitment_description: "To subskrypcja z minimalnym okresem zobowiązania wynoszącym {months} miesięcy, do {date}. Subskrypcja będzie kontynuowana automatycznie po tej dacie do momentu jej anulowania. Nie możesz anulować subskrypcji przed końcem okresu zobowiązania."
  subscription_flexible_title: Płatność miesięczna
  subscription_flexible_description: "To elastyczna subskrypcja, która jest automatycznie odnawiana co miesiąc do momentu jej anulowania. Możesz anulować w dowolnym momencie, a anulowanie wejdzie w życie w następną datę odnowienia."
  products: Materiały
  products_one_time: "(jednorazowo)"
</i18n>
<template>
  <div
    class="rounded-3xl border border-color-custom-grey-7 p-4 sm:p-8 lg:p-10 divide-y divide-custom-grey-7"
    v-if="props.course_setting"
  >
    <div class="pb-6">
      <div
        class="float-left flex rounded-xl justify-center items-center h-14 w-14 bg-gray-200 bg-opacity-70 text-primary mr-4"
      >
        <img
          class="rounded-xl"
          :alt="props.course.course_title"
          :src="props.course.common_featured_image_url"
        />
      </div>
      <h3 class="text-xl font-bold text-custom-grey-1 mb-1">
        {{ props.course.course_title }}
      </h3>
      <p>
        <span v-if="monthlyBilling" class="text-sm text-custom-grey-1">
          {{ formatPrice(props.course_setting.amount, props.course_setting.fee_currency) }}
          / {{ t("month") }}</span
        >
      </p>
    </div>
    <div class="py-6">
      <form action="#">
        <div v-if="props.groups.length > 0">
          <label class="block w-full">
            <span class="text-custom-text pb-1 text-sm font-semibold">
              {{ t("schedule") }}
            </span>
            <select
              name="schedule"
              v-model="selectedGroup"
              class="block py-2 pl-3 border border-gray-300 rounded-md cursor-pointer placeholder-gray-500 transition w-full shadow-sm min-h-12 text-custom-text bg-gray-200 bg-opacity-70 focus:bg-white focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
            >
              <!--                :value="props.selectedGroupID"-->
              <!--                @change="updateGroupID"-->
              <option
                v-for="group in props.groups"
                :value="group"
                :key="group.id"
              >
                {{ group.group_title }}
              </option>
            </select>
          </label>
        </div>
        <div class="py-4">
          <label class="block w-full">
            <span class="text-custom-text pb-1 text-sm font-semibold">
              {{ t("start_date") }}
            </span>
            <date-picker
              v-model="startDate"
              :timePicker="false"
              :autoApply="true"
              :month-change-on-scroll="false"
              :locale="$i18n.locale"
              format="dd/MM/yyyy"
              :minDate="new Date()"
              :ignoreTimeValidation="true"
              :enable-time-picker="false"
              :clearable="false"
            />
          </label>
        </div>
        <!-- TODO: Group schedule -->
        <!--          <div class="pt-4">-->
        <!--            <p-->
        <!--              class="flex items-center text-custom-grey-2 pb-3 text-sm sm:text-normal"-->
        <!--            >-->
        <!--              <svg class="svg-icon svg-attention mr-1.5">-->
        <!--                <use xlink:href="#attention" width="100%" height="100%"></use>-->
        <!--              </svg>-->
        <!--              Group started 21 May 2021-->
        <!--            </p>-->
        <!--            <p-->
        <!--              class="flex items-center text-custom-grey-2 text-sm sm:text-normal"-->
        <!--            >-->
        <!--              <svg class="svg-icon svg-attention mr-1.5">-->
        <!--                <use xlink:href="#attention" width="100%" height="100%"></use>-->
        <!--              </svg>-->
        <!--              For Spanish speakers only-->
        <!--            </p>-->
        <!--          </div>-->
      </form>
    </div>
    <div
      class="py-6"
      v-if="selectedGroup && selectedGroup.instructors.length > 0"
    >
      <h3 class="text-sm font-semibold text-custom-text pb-1">
        {{ t("instructors") }}
      </h3>
      <div
        v-for="instructor in selectedGroup.instructors"
        :key="instructor.id"
        class="flex items-center rounded-xl bg-custom-grey-8 py-2 px-3"
      >
        <div class="flex items-center">
          <img
            :src="instructor.avatar_url"
            :alt="`${instructor.full_name} profile picture`"
            class="h-11 w-11 rounded-full object-cover mr-2"
          />
          <span class="text-custom-grey-1">{{ instructor.full_name }}</span>
        </div>
      </div>
    </div>

    <!-- Subscription Info -->
    <div v-if="monthlyBilling" class="py-6">
      <div class="bg-blue-50 border border-blue-200 rounded-lg p-4">
        <h3 class="text-sm font-semibold mb-2 flex items-center text-blue-900">
          <svg
            class="h-4 w-4 mr-1.5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z"
              clip-rule="evenodd"
            />
          </svg>
          {{
            hasCommitmentPeriod
              ? t("subscription_with_commitment_title")
              : t("subscription_flexible_title")
          }}
        </h3>
        <p class="text-sm text-blue-800">
          <template v-if="hasCommitmentPeriod">
            {{
              t("subscription_with_commitment_description", {
                months: props.course_setting.commitment_months,
                date: commitmentEndDate ? formatDate(commitmentEndDate) : "",
              })
            }}
          </template>
          <template v-else>
            {{ t("subscription_flexible_description") }}
          </template>
        </p>
      </div>
    </div>

    <div class="pt-7">
      <div
        v-if="monthlyBilling && hasCommitmentPeriod"
        class="flex items-center justify-between font-medium text-custom-grey-2 sm:text-lg pb-1"
      >
        <p>
          {{
            t("course_price_with_commitment", {
              price: formatPrice(props.course_setting.amount, props.course_setting.fee_currency),
              months: props.course_setting.commitment_months,
            })
          }}
        </p>
        <p class="whitespace-nowrap">
          {{ formatPrice(totalCommitmentAmount, props.course_setting.fee_currency) }}
        </p>
      </div>
      <div
        v-else-if="monthlyBilling"
        class="flex items-center justify-between font-medium text-custom-grey-2 sm:text-lg pb-1"
      >
        <p>{{ t("course_base_price") }}</p>
        <p class="whitespace-nowrap">
          {{ formatPrice(props.course_setting.amount, props.course_setting.fee_currency) }}
        </p>
      </div>
      <div
        v-else-if="props.base_price"
        class="flex items-center justify-between font-medium text-custom-grey-2 sm:text-lg pb-1"
      >
        <p>
          {{
            t(
              "total_counted",
              {
                base_price: formatPrice(props.base_price, props.course_setting.fee_currency),
                duration: props.course_setting.duration,
              },
              props.course_setting.duration
            )
          }}
        </p>
        <p class="whitespace-nowrap">
          {{
            formatPrice(
              props.base_price * props.course_setting.duration,
              props.course_setting.fee_currency
            )
          }}
        </p>
      </div>
      <div
        v-if="!monthlyBilling && baseDiscount"
        class="flex items-center justify-between font-medium text-custom-grey-2 sm:text-lg pb-3"
      >
        <p>{{ props.course_setting.duration }} {{ t("months_discount") }}</p>
        <p class="text-primary whitespace-nowrap">
          {{ formatPrice(baseDiscount, props.course_setting.fee_currency) }}
        </p>
      </div>
      <!-- Products section -->
      <div
        v-if="hasOrderProducts"
        class="pb-3"
      >
        <div class="flex items-center justify-between font-medium text-custom-grey-2 sm:text-lg pb-1">
          <p>
            {{ t("products") }}
            <span v-if="monthlyBilling" class="text-sm">{{ t("products_one_time") }}</span>
          </p>
          <p class="whitespace-nowrap">
            {{ formatPriceCents(order.products_amount, props.order.currency) }}
          </p>
        </div>
        <div
          v-for="line in visibleOrderLines"
          :key="line.id || line.orderable_id"
          class="flex items-center justify-between text-sm text-custom-grey-2 pl-2"
        >
          <p class="truncate">{{ line.product?.title }}</p>
          <p class="whitespace-nowrap">
            {{ formatPriceCents(line.price_in_cents, props.order.currency) }}
          </p>
        </div>
      </div>
      <div
        v-if="order.coupon"
        class="relative font-medium text-custom-grey-2 sm:text-lg pb-3"
      >
        <div class="flex items-center justify-between">
          <p>{{ t("coupon_discount", { coupon: order.coupon.code }) }}</p>
          <p
            v-if="
              !monthlyBilling ||
              !hasCommitmentPeriod ||
              !couponAppliesToFuturePayments
            "
            class="text-primary whitespace-nowrap"
          >
            {{ formatPrice(-order.discount_amount, props.order.currency) }}
          </p>
          <p v-else class="text-primary whitespace-nowrap">
            {{ formatPrice(totalCouponDiscount, props.order.currency) }}
          </p>
        </div>
        <p
          v-if="
            monthlyBilling &&
            hasCommitmentPeriod &&
            couponAppliesToFuturePayments
          "
          class="text-xs text-custom-grey-2 mt-1"
        >
          {{ formatPrice(-order.discount_amount, props.order.currency) }} ×
          {{ props.course_setting.commitment_months }} =
          {{ formatPrice(totalCouponDiscount, props.order.currency) }}
        </p>
      </div>
      <div class="flex items-center justify-between">
        <p class="font-bold text-custom-text text-lg">
          {{
            monthlyBilling && (hasCommitmentPeriod || hasOrderProducts)
              ? t("payable_now")
              : t("total_to_pay")
          }}
        </p>
        <p class="text-xl sm:text-2xl font-bold whitespace-nowrap">
          {{ formatPrice(displayTotalAmount, props.order.currency) }}
        </p>
      </div>
      <!-- Next payment info for subscriptions with one-time addons -->
      <div
        v-if="showNextPayment && nextPaymentDate"
        class="flex items-center justify-between mt-3 pt-3 border-t border-dashed border-custom-grey-7"
      >
        <p class="text-custom-grey-2 text-sm sm:text-base">
          {{ t("next_payment_on", { date: formatDate(nextPaymentDate) }) }}
        </p>
        <p class="font-semibold whitespace-nowrap">
          {{ formatPrice(nextPaymentAmount, props.order.currency) }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useCurrency } from "@/scripts/application/composables/useCurrency";
import { computed } from "vue";
import type {
  ICourse,
  ICourseSetting,
  IGroup,
  IOrder,
} from "@/scripts/application/types";
import DatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
// import CheckoutLoader from "@/scripts/application/components/CheckoutLoader.vue";

const { t } = useI18n({ inheritLocale: true, useScope: "local" });
const { formatPrice, formatPriceCents } = useCurrency();
// const date = ref(new Date());

const props = defineProps<{
  course: ICourse;
  order: IOrder;
  course_setting: ICourseSetting;
  selectedGroupID: number | null;
  startDate: Date | string | null;
  groups: IGroup[];
  base_price: number | null;
}>();

// const selectedGroup = computed(() => {
//   return props.groups.find((group) => group.id === props.selectedGroupID);
// });

const monthlyBilling = computed<boolean>(() => {
  return (
    props.course_setting.kind === "subscription" ||
    props.course_setting.kind === "individual_subscription"
  );
});

const hasCommitmentPeriod = computed<boolean>(() => {
  return !!(
    props.course_setting.commitment_period_enabled &&
    props.course_setting.commitment_months
  );
});

const totalCommitmentAmount = computed<number>(() => {
  if (!hasCommitmentPeriod.value) return props.course_setting.amount;
  const months = props.course_setting.commitment_months || 1;
  return props.course_setting.amount * months;
});

const displayTotalAmount = computed<number>(() => {
  // Always use order.final_amount as it includes coupon discounts
  return props.order.final_amount;
});

const showNextPayment = computed<boolean>(() => {
  // Show next payment info when using subscription with one-time addons
  return monthlyBilling.value && hasOrderProducts.value;
});

const nextPaymentDate = computed<Date | null>(() => {
  if (!showNextPayment.value || !props.startDate) return null;
  // Next payment is 30 days after the chosen start date
  const chosenStartDate = typeof props.startDate === "string"
    ? new Date(props.startDate)
    : props.startDate;
  const nextDate = new Date(chosenStartDate);
  nextDate.setDate(nextDate.getDate() + 30);
  return nextDate;
});

const nextPaymentAmount = computed<number>(() => {
  // Next payment is the subscription amount (without one-time addons)
  // but includes recurring coupon discount if applicable
  let amount = props.course_setting.amount;
  if (couponAppliesToFuturePayments.value && props.order.discount_amount) {
    amount -= props.order.discount_amount;
  }
  return amount;
});

const hasOrderProducts = computed<boolean>(() => {
  return (props.order.order_lines?.filter((line) => !line._destroy)?.length ?? 0) > 0;
});

const visibleOrderLines = computed(() => {
  return props.order.order_lines?.filter((line) => !line._destroy) ?? [];
});

const couponAppliesToFuturePayments = computed<boolean>(() => {
  if (!props.order.coupon) return false;
  return (
    props.order.coupon.duration === "forever" ||
    props.order.coupon.duration === "repeating"
  );
});

const totalCouponDiscount = computed<number>(() => {
  if (!props.order.discount_amount || !hasCommitmentPeriod.value)
    return -props.order.discount_amount;
  // Calculate total discount across all commitment months
  const months = props.course_setting.commitment_months || 1;
  return -props.order.discount_amount * months;
});

const emit = defineEmits<{
  (event: "update:selectedGroupID", groupID: number | null): void;
  (event: "update:startDate", startDate: Date | string): void;
}>();

const selectedGroup = computed({
  set(group: IGroup | null) {
    emit("update:selectedGroupID", group?.id ?? null);
    if (group?.start_date) {
      const newDate = new Date(group.start_date);
      if (newDate >= new Date()) {
        emit("update:startDate", newDate);
      }
    }
  },
  get(): IGroup | null {
    return (
      props.groups.find((group) => group.id === props.selectedGroupID) || null
    );
  },
});

const commitmentEndDate = computed<Date | null>(() => {
  if (
    !props.order.start_date ||
    !props.course_setting.commitment_period_enabled ||
    !props.course_setting.commitment_months
  ) {
    return null;
  }

  const startDate = new Date(props.order.start_date);
  const endDate = new Date(startDate);
  endDate.setMonth(endDate.getMonth() + props.course_setting.commitment_months);

  return endDate;
});

const formatDate = (date: Date): string => {
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

const baseDiscount = computed(() => {
  if (!props.base_price) return 0.0;
  return (
    props.course_setting.amount -
    props.base_price * props.course_setting.duration
  );
});

const startDate = computed({
  set(date: Date | string) {
    console.log(date);
    if (date instanceof Date) {
      return emit(
        "update:startDate",
        `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      );
    }
    emit("update:startDate", date);
  },
  get(): Date | string {
    if (typeof props.startDate === "string") {
      return new Date(props.startDate);
    }
    if (props.startDate !== null && typeof props.startDate === "object") {
      return props.startDate;
    }
    return new Date();
  },
});
//
// function updateGroupID(e) {
//   debugger
//   emit('update:selectedGroupID', e.target.value)
// }
</script>
